module.exports = __webpack_public_path__ + "static/soc1-0bff5565c9a42ffb7d7a30bf6cc91d79.png";